import script from "./MultiselectElement.vue?vue&type=script&lang=js"
export * from "./MultiselectElement.vue?vue&type=script&lang=js"

import "./MultiselectElement.vue?vue&type=style&index=0&id=3225b25a&lang=scss"

const __exports__ = script;

export default __exports__